import { render, staticRenderFns } from "./ReceivableRegisterCard.vue?vue&type=template&id=744dd976&"
import script from "./ReceivableRegisterCard.vue?vue&type=script&lang=js&"
export * from "./ReceivableRegisterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports